/* Tiny opt-in bootstrap; no Studio dependency request outside its three gates. */
(function () {
  'use strict';
  const storefront = window.BSStorefront, source = document.currentScript;
  if (!source || !storefront?.shopTransitions?.studioAllowed()) return;
  if (storefront.animationStudio) { document.querySelectorAll('.bs-home-hub').forEach(root => storefront.animationStudio.open(root)); return; }
  function asset(value, name) {
    try {
      const url = new URL(value, location.href), origin = new URL(source.src, location.href).origin;
      return /^https?:$/.test(url.protocol) && url.origin === origin && url.pathname.endsWith('/' + name) ? url.href : null;
    } catch (ignored) { return null; }
  }
  const src = asset(source.getAttribute('data-studio-script'), 'bs-animation-studio.js');
  const css = asset(source.getAttribute('data-studio-style'), 'bs-animation-studio.css');
  if (!src || !css) return;
  const script = document.createElement('script'); script.src = src;
  script.setAttribute('data-studio-style', css); script.setAttribute('data-bs-studio-loading', 'active');
  function clean() {
    script.onload = null; script.onerror = null; script.removeAttribute('data-bs-studio-loading'); script.remove();
    window.removeEventListener('pagehide', clean);
  }
  script.onload = clean; script.onerror = clean;
  window.addEventListener('pagehide', clean);
  document.head.appendChild(script);
})();
